import EditChatNameModal from './EditChatNameModal';

export default EditChatNameModal;